<template>
  <div>
    <div class="button-containers m-0">
      <button
        v-if="checkAuthorRoomMoney"
        class="btn primary small"
        :disabled="
          !isRowSelected || bookingInfo.checked_out || bookingInfo.status == 1
        "
        @click="openAddServiceDialog()"
      >
        + Dịch vụ
      </button>
      <button
        v-if="checkAuthorAddTransaction"
        class="btn primary small"
        :disabled="
          !isRowSelected || bookingInfo.checked_out || bookingInfo.status == 1
        "
        @click="openTransactionDialog()"
      >
        + Giao dịch
      </button>
      <!-- <button
        class="btn primary small"
        :disabled="!isRowSelected"
        @click="openAddRoomFeeDialog()"
      >
        + Tiền phòng
      </button> -->
      <button
        v-if="checkAuthorHKService"
        class="btn primary small"
        :disabled="
          !isRowSelected || bookingInfo.checked_out || bookingInfo.status == 1
        "
        @click="openAddHkDialog()"
      >
        + Dịch vụ buồng
      </button>
      <button
        v-if="checkAuthorProcessTransction"
        class="btn primary small"
        :disabled="
          !isRowSelected ||
          transactions.length === 0 ||
          transactions[0].invoice_number_sequence ||
          selectedTab.label === 'V'
        "
        @click="openTransactionProcessDialog"
      >
        <!-- {{ $t('button.cancel') }} -->
        Xử lý GD
      </button>
      <button
        v-if="checkAuthorPayment"
        class="btn primary small"
        :disabled="
          !isRowSelected ||
          transactions.length === 0 ||
          transactions[0].invoice_number_sequence ||
          selectedTab.label === 'V' ||
          depositRefundPermit
        "
        @click="openPaymentDialog()"
      >
        <!-- {{ $t('button.cancel') }} -->
        Thanh toán
      </button>
      <button
        v-if="checkAuthorRefund"
        class="btn primary small"
        :disabled="
          !isRowSelected ||
          transactions.length === 0 ||
          selectedTab.label === 'V' ||
          !depositRefundPermit
        "
        @click="openRefundDialog(refundType)"
      >
        <!-- {{ $t('button.cancel') }} -->
        Hoàn tiền
      </button>
      <!-- <button class="btn primary small" disabled>
        In đặt cọc
      </button> -->
      <button
        class="btn primary small"
        :disabled="!isRowSelected || bookingInfo.status == 1"
        @click="handlePrintInvoice"
      >
        In hóa đơn
      </button>
      <button
        class="btn primary small"
        :disabled="bookingInfo.status == 1"
        @click="handlePrintProvisionalInvoice"
      >
        In hóa đơn tạm tính
      </button>
      <button
        class="btn primary small"
        :disabled="!isRowSelected || bookingInfo.status == 1"
        @click="handlePrintDetailInvoice"
      >
        <!-- !isRowSelected ||
        bookingInfo.status == 1 ||
        transactions?.length !== 1
        !transactions[0]?.invoice_number_sequence -->
        In chi tiết hóa đơn
      </button>
    </div>
    <!-- Them dich vu buong -->
    <!-- <el-dialog
      :title="
        isEdit
          ? $t('dialog.titleHouseKeepingServiceEdit')
          : $t('dialog.titleHouseKeepingServiceAdd')
      "
      :visible.sync="addHKSDialog"
      :close-on-click-modal="false"
      width="1100px"
    >
      <AddHouseKeepingServiceDialog
        ref="AddHouseKeepingServiceDialog"
        v-model="kpItem"
        :kp-item-info="bookingInfo"
        :kp-item-prop="kpItem"
        :is-edit="isEditHk"
      />
      <span slot="footer" class="dialog-footer">
        <div v-if="!isDetailView" class="button-containers">
          <button
            class="btn primary small outline"
            @click="addHKSDialog = false"
          >
            Huỷ
          </button>
          <button
            v-if="isEditHk"
            class="btn primary small"
            @click="updateHkItem"
          >
            Cập nhật
          </button>
          <button v-else class="btn primary small" @click="openAddHkDialog">
            Tạo mới
          </button>
        </div>
      </span>
    </el-dialog> -->

    <el-dialog
      title="Xử lý giao dịch"
      :visible.sync="transactionProcessDialog"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div v-if="transactions.length <= 1" class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="checks-wrap">
                  <input
                    id="cpSpdTp8"
                    v-model="transactionProcessValue"
                    type="radio"
                    value="1"
                  />
                  <label for="cpSpdTp8">Chi tiết giao dịch</label>
                </div>
              </div>
            </div>
          </div>
          <div v-if="transactions.length <= 1" class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="checks-wrap">
                  <input
                    id="cpSpdTp9"
                    v-model="transactionProcessValue"
                    type="radio"
                    value="2"
                  />
                  <label for="cpSpdTp9">Sửa giao dịch</label>
                </div>
              </div>
            </div>
          </div>
          <div v-if="transactions.length <= 1" class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="checks-wrap">
                  <input
                    id="cpSpdTp10"
                    v-model="transactionProcessValue"
                    type="radio"
                    value="3"
                  />
                  <label for="cpSpdTp10">Hủy giao dịch</label>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="checks-wrap">
                  <input
                    id="cpSpdTp11"
                    v-model="transactionProcessValue"
                    type="radio"
                    value="4"
                  />
                  <label for="cpSpdTp11">Chuyển giao dịch</label>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            v-if="transactions.length === 1 && transactions[0]?.money > 0"
            class="das-form-row"
          >
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="checks-wrap">
                  <input
                    id="cpSpdTp12"
                    v-model="transactionProcessValue"
                    type="radio"
                    value="5"
                  />
                  <label for="cpSpdTp12">Tách giao dịch</label>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="transactionProcessDialog = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="onTransactionProcess">
            Đồng ý
          </button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="Hủy giao dịch"
      :visible.sync="isCancelTransaction"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="das-form-input">
                  <div class="label required">Lý do hủy giao dịch</div>
                  <textarea v-model="cancelTransaction.reason" :rows="3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="isCancelTransaction = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="onCancelTransaction">
            Đồng ý
          </button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="Chuyển giao dịch"
      :visible.sync="transferTransactionDialog"
      :close-on-click-modal="false"
      width="500px"
      @close="closeTransferTransactionDialog"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">Chuyển từ</div>
          <InfoList :columns="2">
            <InfoListLabel>Tên khách</InfoListLabel>
            <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

            <InfoListLabel>Đặt phòng</InfoListLabel>
            <InfoListValue>{{ bookingInfo.sub_booking_code }}</InfoListValue>

            <InfoListLabel>Trang hiện tại</InfoListLabel>
            <InfoListValue>{{
              transactions[0]?.trans_page_name
            }}</InfoListValue>
          </InfoList>
        </div>
        <div class="das-form-group mt-10">
          <div class="das-form-group-title">Chuyển đến</div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input in-line">
                <div class="label">Đặt phòng</div>
                <div style="display: flex; gap: 10px; width: 100%">
                  <input
                    v-model="transferTransactionSubmitForm.room_code"
                    type="text"
                  />
                  <das-button
                    color="primary"
                    size="small"
                    append-icon="search"
                    @click="searchRoomOnTransferTransactionDialog()"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="das-form-input in-line">
                  <div class="label">Tên khách</div>
                  <span class="value">{{
                    transferTransactionSubmitForm.customer_name
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input in-line">
                <div class="label">Phòng</div>
                <span class="value">{{
                  transferTransactionSubmitForm.room_num
                }}</span>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input in-line">
                <div class="label">
                  <span class="required">Trang giao dịch</span>
                </div>
                <el-select
                  v-model="transferTransactionSubmitForm.trans_page"
                  placeholder=""
                >
                  <el-option
                    v-for="item1 in allTranPages"
                    :key="item1.code"
                    :label="item1.code"
                    :value="item1.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="transferTransactionDialog = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="onTransferTransaction">
            Đồng ý
          </button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="Tách giao dịch"
      :visible.sync="splitTransactionDialog"
      :close-on-click-modal="false"
      width="500px"
      @close="resetSplitForm"
    >
      <validation-observer ref="splitFormValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <InfoList :columns="1">
              <InfoListLabel>
                <span>Tên khách</span>
              </InfoListLabel>
              <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

              <InfoListLabel>
                <span>Trang giao dịch</span>
              </InfoListLabel>
              <InfoListValue>{{ selectedTab?.label || null }}</InfoListValue>

              <InfoListLabel>
                <span>Ngày giao dịch</span>
              </InfoListLabel>
              <InfoListValue>{{
                $displayDate(transactions[0]?.trans_date)
              }}</InfoListValue>

              <InfoListLabel>
                <span>Mã giao dịch</span>
              </InfoListLabel>
              <InfoListValue>{{ transactions[0]?.trans_code }}</InfoListValue>

              <InfoListLabel>
                <span>Mô tả</span>
              </InfoListLabel>
              <InfoListValue>{{ transactions[0]?.description }}</InfoListValue>

              <InfoListLabel>
                <span>Tổng tiền</span>
              </InfoListLabel>
              <InfoListValue
                >{{
                  $displayCurrency(transactions[0]?.money) || 0
                }}
                VND</InfoListValue
              >

              <InfoListLabel>
                <span>Số tiền còn lại</span>
              </InfoListLabel>
              <InfoListValue
                >{{ $displayCurrency(leftMoney) }} VND</InfoListValue
              >
            </InfoList>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Tách theo</div>
                  <div class="checkbox-container">
                    <div class="checks-wrap">
                      <input
                        id="cpSpdTp30"
                        v-model="splitTransactionType"
                        type="radio"
                        :value="1"
                        @change="onChangeSplitTransactionType"
                      />
                      <label for="cpSpdTp30">Theo số tiền</label>
                    </div>
                    <div class="checks-wrap ml-10">
                      <input
                        id="cpSpdTp31"
                        v-model="splitTransactionType"
                        type="radio"
                        :value="2"
                        @change="onChangeSplitTransactionType"
                      />
                      <label for="cpSpdTp31">Theo phần trăm</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required" name="Tách đến trang">
                  <div class="das-form-input">
                    <div class="label required">Tách đến trang</div>
                    <el-select
                      v-model="splitMoneyForm.transPage"
                      placeholder=""
                    >
                      <el-option
                        v-for="item in allTranPages"
                        :key="item.id"
                        :label="item.code"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div v-if="splitTransactionType === 1" class="das-form-input">
                  <div class="label required">Số tiền tách</div>
                  <validation-provider rules="required" name="Số tiền tách">
                    <VxCurrencyInput v-model="splitMoneyForm.money" />
                  </validation-provider>
                </div>
                <div v-else class="flex gap-10">
                  <div class="das-form-input" style="flex: 1">
                    <div class="label required">Số phần trăm</div>
                    <validation-provider
                      rules="required|percent"
                      name="Số phần trăm"
                    >
                      <input v-model="splitMoneyForm.percent" type="text" />
                    </validation-provider>
                  </div>
                  <div class="das-form-input" style="flex: 3">
                    <div class="label">Thành tiền</div>
                    <div class="read-only-input">
                      {{ $displayCurrency(splitMoneyForm.money) }}
                    </div>
                    <!-- <CurrencyInput v-model="splitMoneyForm.money" /> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Ghi chú</div>
                  <textarea
                    v-model="splitMoneyForm.note"
                    :rows="3"
                    style="width: 100%"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <!-- <div
        v-if="splitTransactionType === '1'"
        class="mt-10"
        style="height: 400px"
      >
        <GridVx
          ref="splitAmountGrid"
          :columns="splitColsByAmount"
          :auto-select-first-row="false"
          dom-layout="scroll"
          :suppress-row-click-selection="true"
          :rows="splitRows"
          :context="context"
          class="agGrid"
        />
      </div>
      <div v-else class="mt-10" style="height: 400px">
        <GridVx
          ref="splitPercentGrid"
          :columns="splitColsByPercent"
          :auto-select-first-row="false"
          :suppress-row-click-selection="true"
          dom-layout="scroll"
          :rows="splitRows"
          :context="context"
          class="agGrid"
        />
      </div> -->
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="splitTransactionDialog = false"
          >
            Đóng
          </button>
          <button
            :disabled="leftMoney < 0"
            class="btn primary small"
            @click="onSaveSplitAmount"
          >
            Cập nhật
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- <el-dialog
      :title="paymentTitle"
      :visible.sync="paymentDialog"
      :close-on-click-modal="false"
      width="1000px"
    > -->
    <!-- <PaymentComponent
        v-if="paymentType === 'payment'"
        ref="paymentComponent"
        :key-a="keyA"
        @surplusChange="leftMoneyTrigger"
        @paymentDone="onPaymentDone"
      /> -->
    <!-- <RefundComponent
        v-if="paymentType === 'refund'"
        ref="refundComponent"
        :key-a="keyA"
        @paymentDone="onPaymentDone"
        @surplusChanged="onRefundSurplusChange"
      /> -->
    <!-- <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="paymentDialog = false"
          >
            Đóng
          </button>
          <button
            v-if="paymentType === 'payment'"
            :disabled="!paymentPermit"
            class="btn primary small"
            @click="submitPaymentForm"
          >
            Thanh toán
          </button> -->
    <!-- <button
            v-else
            class="btn primary small"
            :disabled="!refundPermit"
            @click="submitRefundForm"
          >
            Hoàn tiền
          </button> -->
    <!-- </div> -->
    <!-- </span> -->
    <!-- </el-dialog> -->
    <search-folio-component
      ref="searchFolioComponent"
      :search-folio-component-index="searchFolioComponentIndex"
      @onFolioSelect="onFolioSearchSelect"
    />
    <addMultipleTransactionsComponents
      ref="addMultipleTransactionsComponent"
      :add-multiple-transactions-index="addMultipleTransactionsIndex"
    />
    <EditTransactionComponent
      ref="editTransactionComponent"
      :is-detail-popup="isDetailPopup"
      @submitDone="transactionProcessDialog = false"
      @resetDialog="isDetailPopup = false"
    />
    <AddServiceComponent
      ref="addServiceComponent"
      :is-detail-popup="isDetailPopup"
      @done="transactionProcessDialog = false"
      @resetDialog="isDetailPopup = false"
    />
    <AddHouseKeepingServiceDialog
      ref="AddHouseKeepingServiceDialog"
      v-model="kpItem"
      :kp-item-info="kpItemInfo"
      :kp-item-prop="kpItem"
      :is-detail-popup="isDetailPopup"
      @submitDone="onHouseKeepingDialogDone"
      @resetDialog="isDetailPopup = false"
    />
    <PaymentComponent ref="paymentComponent" />
    <RefundComponent ref="refundComponent" />
  </div>
</template>

<script>
import { checkAuthorized } from '@/utils/helper'
import DasButton from '@/components/ui/DasButton.vue'
import { getCodeBase } from '@/api/common/code_base'
import PaymentComponent from './components/paymentComponent.vue'
import RefundComponent from './components/refundComponent.vue'
import AddServiceComponent from './components/addServiceComponent.vue'
import AddHouseKeepingServiceDialog from '@/views/mci/houseKeeper/components/addHouseKeepingServiceDialog.vue'
import {
  CellHeaderAddIcon,
  CellRenderSelect,
  CellRenderTextInput,
  CellRenderDeleteIcon,
  CellRenderCurrencyInput,
  CellRenderSelectWithSearchTable
} from '@/utils/cellRenders'
import {
  cancelTransaction,
  transferTransactionApi,
  splitTransaction,
  getTransactionConfig
} from '@/api/cashier_service/postTransaction'
import {
  addMultiRoomTransaction
  // getTransactionByPage
} from '@/api/cashier_service/postTransaction'
import {
  // eslint-disable-next-line no-unused-vars
  getRoomServiceGroupApi,
  getRoomServiceProductListApi
} from '@/api/Service_Policy/roomServiceGroup'
import { getSpecialServiceTransApi } from '@/api/Service_Policy/specialService'
import SearchFolioComponent from './components/searchFolioComponent.vue'
import addMultipleTransactionsComponents from './components/addMultipleTransactionsComponent.vue'
import EditTransactionComponent from './components/editTransactionComponent.vue'
import bus from '@/utils/bus'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellHeaderAddIcon,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderSelect,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderTextInput,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderDeleteIcon,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderSelectWithSearchTable,
    DasButton,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCurrencyInput,
    // eslint-disable-next-line vue/no-unused-components
    PaymentComponent,
    RefundComponent,
    // eslint-disable-next-line vue/no-unused-components
    AddHouseKeepingServiceDialog,
    SearchFolioComponent,
    addMultipleTransactionsComponents,
    EditTransactionComponent,
    AddServiceComponent
  },
  props: {},
  data() {
    return {
      refundType: 1,
      isDetailPopup: false,
      // author
      checkAuthorAddTransaction: false,
      checkAuthorRoomMoney: false,
      checkAuthorHKService: false,
      checkAuthorProcessTransction: false,
      checkAuthorPayment: false,
      checkAuthorRefund: false,
      //
      // keyA: 0,
      searchFolioComponentIndex: 0,
      addMultipleTransactionsIndex: 0,
      // paymentPermit: false,
      // refundPermit: false,
      isEditHk: false,
      // paymentType: null,
      splitMoneyForm: {
        id: null,
        money: null,
        transPage: null,
        note: null,
        percent: null
      },
      selectValue: null,
      roomLevelOptions: [],
      paymentTitleNumber: null,
      searchFolioType: 1, // 1 - router, 2 - transfer
      cancelTransaction: {
        reason: null
      },
      transPageOptions: [],
      splitColsByAmount: [
        {
          headerName: this.$t('grid.column.transactionDate'),
          field: 'trans_date',
          tter: params => {
            if (params?.data?.trans_date) {
              return this.$moment(params?.data?.trans_date).format('YYYY-MM-DD')
            } else {
              return null
            }
          },
          width: 150
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'trans_code',
          width: 100
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          width: 200
        },
        {
          headerName: this.$t('grid.column.amount'),
          // field: 'amount',
          field: 'money',
          width: 200,
          tter: params => {
            return Number(params.data?.money).toLocaleString('en') || null
          }
        },
        {
          headerName: this.$t('grid.column.splitAmount'),
          field: 'splitAmount',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: this.$t('grid.column.restAmount'),
          field: 'restAmount',
          width: 200,
          tter: params => {
            if (isNaN(params.data?.restAmount)) {
              return null
            } else {
              return Number(params.data?.restAmount).toLocaleString('en')
            }
          }
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          cellRenderer: 'CellRenderTextInput'
        }
      ],
      kpItemInfo: {
        booking_code: null,
        confirm_code: null,
        arrive_date: null,
        depart_date: null,
        sub_booking_group_id: null,
        room_num: null,
        group: null,
        id: null
      },
      // DIALOG
      splitTransactionType: 1,
      // addHKSDialog: false,
      isCancelTransaction: false,
      transferTransactionDialog: false,
      splitTransactionDialog: false,
      transactionProcessDialog: false,
      paymentDialog: false,
      // GRID
      splitColsByPercent: [
        {
          headerName: this.$t('grid.column.transactionDate'),
          field: 'trans_date',
          tter: params => {
            if (params?.data?.trans_date) {
              return this.$moment(params?.data?.trans_date).format('YYYY-MM-DD')
            } else {
              return null
            }
          }
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'trans_code'
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description'
        },
        {
          headerName: this.$t('grid.column.amount'),
          field: 'money',
          // field: 'amount',
          width: 200,
          tter: params => {
            return Number(params.data?.money).toLocaleString('en') || null
          }
        },
        {
          headerName: this.$t('grid.column.splitPercent'),
          field: 'splitPercent',
          cellRenderer: 'CellRenderTextInput'
        },
        {
          headerName: this.$t('grid.column.splitAmount'),
          field: 'splitAmount',
          width: 200
          // tter: params => {
          //   return Number(params.data?.splitAmount).toLocaleString('en') || null
          // }
        },
        {
          headerName: this.$t('grid.column.restAmount'),
          field: 'restAmount',
          width: 200,
          tter: params => {
            if (isNaN(params.data?.restAmount)) {
              return null
            } else {
              return Number(params.data?.restAmount).toLocaleString('en')
            }
          }
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          cellRenderer: 'CellRenderTextInput'
        }
      ],
      columns2: [
        {
          headerName: 'Mã',
          field: 'code'
        },
        {
          headerName: 'Tên',
          field: 'name'
        },
        {
          headerName: 'Số tiền',
          field: 'price',
          tter: params => {
            if (params.data?.price) {
              return Number(params.data.price).toLocaleString('en')
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Số lượng',
          field: 'quantity',
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'number'
            }
          }
        },
        {
          headerName: 'Thành tiền',
          field: 'money_total',
          tter: params => {
            if (params.data?.money_total) {
              return Number(params.data.money_total).toLocaleString('en')
            } else {
              return null
            }
          }
        },
        {
          headerName: '% Phí',
          field: 'fee'
        },
        {
          headerName: '% Thuế',
          field: 'tax'
        }
      ],
      rows2: [],
      dfSplitRows: [],
      splitRows: [],
      // OTHERs
      tab: null,
      // paymentTitle: null,
      currencyOptions: [],
      paymentMethods: [],
      paymentOptions: [],
      roomPaymentForm: {
        money: null,
        note: null,
        sub_booking_group_id: null,
        sub_transaction_id: null,
        trans_date: null,
        trans_page: null,
        invoice_num: null,
        currency_id: null,
        debt_account_id: null,
        bank_account_id: null,
        card_num: null
      },
      paymentConfigs: [
        {
          name: 'Tiền mặt'
        },
        {
          name: 'Chuyển khoản'
        },
        {
          name: 'Công nợ'
        },
        {
          name: 'Thẻ tín dụng'
        },
        {
          name: 'Thẻ trả trước'
        }
      ],
      refundConfigs: [
        {
          name: 'Tiền mặt'
        }
      ],
      splitTransactionInfo: {
        id: null,
        transPage: null,
        money: null,
        note: null
      },
      transferTransactionSubmitForm: {
        trans_page: null,
        sub_booking_group_id: null,
        room_num: null,
        room_code: null,
        customer_name: null
      },
      transactionProcessValue: '2',
      isDetailView: false,
      kpItem: {
        trading_date: this.$displayDate(new Date()),
        quantity: null,
        trans_page: null,
        invoice_discount_type: null,
        foc: false,
        invoice_discount_value: null,
        money_total: 0,
        note: null,
        room_service_group_id: null,
        room_service_group_name: null,
        sub_booking_group_id: null,
        room_transaction_id: null,
        fee: null,
        tax: null,
        products: []
      },
      roomServiceGroupOptions: [],
      isEdit: false,
      roomChargeForm: {
        subBookingGroupId: null,
        dateFrom: null,
        dateTo: null,
        transPage: null,
        addAllGroup: false,
        beMaster: false,
        toMaster: false
      },
      customerInfo: {
        surplus: null,
        booking_group_code: true
      }
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    selectedTab() {
      return this.$store.getters['selectedTab']
    },
    allTranPages() {
      return this.$store.getters['allTranPages']
    },
    transactions() {
      return this.$store.getters['transactions']
    },
    // haveNegativeTransaction() {
    //   let data = false
    //   this.transactions.map(item => {
    //     if (item.money < 0) {
    //       data = true
    //     }
    //   })
    //   return data
    // },
    leftSurplusAmount() {
      // alert(this.customerInfo.surplus)
      // alert(this.roomPaymentForm.money)
      return (
        Number(this.bookingInfo.surplus) - Number(this.roomPaymentForm.money)
      )
    },
    leftMoney() {
      return (
        Number(this.transactions[0]?.money) - Number(this.splitMoneyForm.money)
      )
    },
    isRowSelected() {
      return this.$store.getters['rowSelected'] || false
    },
    depositRefundPermit() {
      let output = true
      if (
        this.transactions.length === 1 &&
        this.transactions[0].invoice_number_sequence &&
        this.transactions[0].refundable
      ) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.refundType = 1
        return output
      }
      this.transactions.forEach(item => {
        if (!item.folio_num && item.money < 0) {
          // do nothing
        } else {
          output = false
        }
      })

      this.transactions.forEach(item => {
        if (!item.refundable) {
          output = false
        }
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.refundType = 2
      // output true: co the hoan tien
      // output false: khong the hoan tien
      return output
    }
  },
  watch: {
    isCancelTransaction() {
      this.isCancelTransaction
        ? null
        : this.$nullValueInObj(this.cancelTransaction)
    },
    transactionProcessDialog() {
      this.transactionProcessDialog ? null : this.resetTransctionProcessDialog()
    },
    paymentDialog() {
      this.paymentDialog ? null : this.resetPaymentForm()
    },
    // addRoomFeeDialog() {
    //   this.addRoomFeeDialog ? null : this.resetRoomChargeForm()
    // },
    // addHKSDialog() {
    //   this.addHKSDialog ? null : this.resetAddHKSDialog()
    // },
    'splitMoneyForm.percent'() {
      const money = this.transactions[0]?.money
      this.splitMoneyForm.money = money * 0.01 * this.splitMoneyForm.percent
    },
    splitTransactionType() {
      this.splitMoneyForm.money = null
    },
    transferTransactionDialog() {
      if (this.transferTransactionDialog) {
        this.transferTransactionSubmitForm.trans_page =
          this.allTranPages[0]?.id || null
      }
    }
    // edit transaction
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  async mounted() {
    // check author
    this.checkAuthorAddTransaction = checkAuthorized(
      'TRANSACTION_ADD_TRANSACTION'
    )
    this.checkAuthorRoomMoney = checkAuthorized('TRANSACTION_ADD_SERVICE')
    // this.checkAuthorRoomMoney = true
    this.checkAuthorHKService = checkAuthorized(
      'TRANSACTION_ADD_ROOM_SERVICE_GROUP'
    )
    this.checkAuthorProcessTransction = checkAuthorized('TRANSACTION_HANDLE')
    this.checkAuthorPayment = checkAuthorized('TRANSACTION_PAYMENT')
    this.checkAuthorRefund = checkAuthorized('TRANSACTION_REFUND')
    //
    await this.getAllTranPage()
    await this.fnGetSpecServiceOptions()
    await this.getTransactionConfigList()
  },
  methods: {
    closeTransferTransactionDialog() {
      this.$nullValueInObj(this.transferTransactionSubmitForm)
    },
    resetSplitForm() {
      this.splitTransactionType = 1
      this.$nullValueInObj(this.splitMoneyForm)
      this.splitMoneyForm.transPage = this.allTranPages[0].id
    },
    onHouseKeepingDialogDone() {
      this.transactionProcessDialog = false
      this.$store.dispatch('cashier/changeTransactionListIndex')
    },
    // onRefundSurplusChange(amount) {
    //   if (amount < 0) {
    //     this.refundPermit = false
    //   } else {
    //     this.refundPermit = true
    //   }
    // },
    resetTransctionProcessDialog() {
      this.transactionProcessValue = '2'
    },
    openAddServiceDialog() {
      this.$refs.addServiceComponent.openAddServiceDialog()
    },
    openUpdateServiceDialog() {
      this.$refs.addServiceComponent.openUpdateServiceDialog()
    },
    onFolioSearchSelect(row) {
      this.transferTransactionSubmitForm.sub_booking_group_id = row.id
      this.transferTransactionSubmitForm.room_code = row.room_code
      this.transferTransactionSubmitForm.customer_name = row.full_name
      this.transferTransactionSubmitForm.room_num = row.room_num
    },
    // onPaymentDone() {
    //   this.paymentDialog = false
    //   this.$store.dispatch('cashier/changeTransactionListIndex')
    // },
    // leftMoneyTrigger(value) {
    //   if (value === 0) {
    //     this.paymentPermit = true
    //   } else {
    //     this.paymentPermit = false
    //   }
    // },
    async openAddHkDialog() {
      Object.assign(this.kpItemInfo, this.bookingInfo)
      this.kpItem.sub_booking_group_id = this.bookingInfo.id
      this.$refs.AddHouseKeepingServiceDialog.dialogFormVisible = true
    },
    // async updateHkItem() {
    //   const data = this.$refs.AddHouseKeepingServiceDialog.kpItem
    //   const rows = this.$refs.AddHouseKeepingServiceDialog.rows2
    //   data.products = rows
    //   if (data.invoice_discount_type === 1) {
    //     data.money_total -=
    //       0.01 * Number(data.invoice_discount_value) * data.money_total
    //   } else if (data.invoice_discount_type === 2) {
    //     data.money_total -= Number(data.invoice_discount_value)
    //   }
    //   await updateHouseKeepingServiceInvoicesApi(data)
    //     .then(async res => {
    //       const message = res.message
    //       this.addHKSDialog = false
    //       this.transactionProcessDialog = false
    //       this.$message({
    //         type: 'success',
    //         message: this.$t(`successMsg.${message}`)
    //       })
    //       this.$store.dispatch('cashier/changeTransactionListIndex')
    //     })
    //     .catch(error => {
    //       const message = error.response?.data?.message || 'default'
    //       this.$message({
    //         type: 'error',
    //         message: this.$t(`errorMsg.${message}`)
    //       })
    //     })
    // },
    resetAddHKSDialog() {
      this.isEditHk = false
      this.$refs.AddHouseKeepingServiceDialog.resetForm()
    },
    resetRoomChargeForm() {
      this.roomChargeForm = {
        subBookingGroupId: null,
        dateFrom: null,
        dateTo: null,
        transPage: null,
        addAllGroup: false,
        beMaster: false,
        toMaster: false
      }
    },
    SelectInputChange(colName, data, value) {
      const idx = data.rowIndex
      this.dialogTransacRows[idx][colName] = value
    },
    async getAllTranPage() {
      const data = await getCodeBase({
        p_code: 'TRANPAGE'
      })
      const allTranPages = data.data || []
      this.$store.dispatch('cashier/addAllTranPages', allTranPages)
      this.transferTransactionSubmitForm.trans_page = allTranPages[0].id
      this.splitMoneyForm.transPage = allTranPages[0].id
    },
    resetPaymentForm() {
      // if (this.$refs.paymentComponent) {
      //   this.$refs.paymentComponent.onResetData()
      // }
      // if (this.$refs.refundComponent) {
      //   this.$refs.refundComponent.onResetData()
      // }
      // this.$nullValueInObj(this.roomPaymentForm)
    },
    async changeRoomServiceGroupId() {
      const list = await getRoomServiceProductListApi(
        this.kpItem.room_service_group_id
      )
      this.rows2 = list.data
      if (this.rows2.length > 0) {
        this.kpItem.include_tax_fee = this.rows2[0].include_tax_fee
        this.kpItem.fee = this.rows2[0].fee
        this.kpItem.tax = this.rows2[0].tax
      } else {
        this.kpItem.include_tax_fee = null
        this.kpItem.fee = null
        this.kpItem.tax = null
      }
    },
    async getTransactionConfigList() {
      const paymentData = await getTransactionConfig({ type: 1 })
      const depositData = await getTransactionConfig({ type: 2 })
      const refundData = await getTransactionConfig({ type: 3 })
      this.paymentTransactionConfig = paymentData?.data || []
      this.depositTransactionConfig = depositData?.data || []
      this.refundTransactionConfig = refundData?.data || []
    },
    onChangeDateAddCharge(from, to) {
      this.roomChargeForm.dateFrom = from
      this.roomChargeForm.dateTo = to
    },
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.dialogTransacRows.splice(idx, 1)
    },
    selectSearchTableChange(params, row, colName) {
      if (colName === 'sub_transaction_desc') {
        const agGrid = this.$refs.dialogTransactionGrid.gridApi
        this.dialogTransacRows[params.rowIndex]['sub_transaction_id'] =
          row.sub_transaction_id
        agGrid.forEachNode(node => {
          if (node.rowIndex === params.rowIndex) {
            node.setDataValue('transaction_desc', row.transaction_desc)
            node.setDataValue('service_fee', row.service_fee)
            node.setDataValue('sub_transaction_id', row.sub_transaction_id)
            node.setDataValue('tax', row.tax)
          }
        })
        return
      }
    },
    async fnGetSpecServiceOptions() {
      const data = await getSpecialServiceTransApi({ transaction_group: 1 })
      this.transOptions = data.data.map(item => ({
        ...item,
        transaction_id_desc: `${item.transaction_id} - ${item.transaction_desc}`,
        sub_transaction_id_desc: `${item.sub_transaction_id} - ${item.sub_transaction_desc}`
      }))
    },
    // changeCurrencyInput(params, value, colNm) {
    //   // Table: transactionGrid
    //   // amountExcludeTax change
    //   if (colNm === 'amountExcludeTax' && value) {
    //     const feeAmount =
    //       Number(value) *
    //       0.01 *
    //       Number(this.dialogTransacRows[params.rowIndex]['service_fee'])
    //     const taxMount =
    //       Number(value) *
    //       0.01 *
    //       Number(this.dialogTransacRows[params.rowIndex]['tax'])
    //     const money = Number(value) + feeAmount + taxMount
    //     const agGrid = this.$refs.dialogTransactionGrid.gridApi
    //     agGrid.forEachNode(node => {
    //       if (node.rowIndex === params.rowIndex) {
    //         node.setDataValue('feeAmount', feeAmount)
    //         node.setDataValue('taxAmount', taxMount)
    //         node.setDataValue('taxAmount', taxMount)
    //         node.setDataValue('money', money)
    //         node.setDataValue('amountExcludeTax', value)
    //       }
    //     })
    //   }
    //   // money (amountIncludeTax) change
    //   this.rows2[params.rowIndex]['money_total'] =
    //     value * Number(this.rows2[params.rowIndex]['price'])
    //   const agGrid = this.$refs.agGrid2.gridApi
    //   agGrid.forEachNode(node => {
    //     if (node.rowIndex === params.rowIndex) {
    //       node.setDataValue(
    //         'money_total',
    //         this.rows2[params.rowIndex]['money_total']
    //       )
    //     }
    //   })
    //   this.rows2[params.rowIndex][colNm] = value
    //   let amount = 0
    //   this.rows2.forEach(item => {
    //     if (Number(item.quantity) && Number(item.price)) {
    //       amount += Number(item.quantity) * Number(item.price)
    //     }
    //   })
    //   this.kpItem.money_total = amount
    // },
    textInputChange(params, value, colNm) {
      // if (value === '') {
      //   return
      // }

      // Split Amount change
      if (colNm === 'splitAmount') {
        const restAmount =
          Number(this.splitRows[params.rowIndex]['money']) - Number(value)
        const agGrid = this.$refs.splitAmountGrid.gridApi
        agGrid.forEachNode(node => {
          if (node.rowIndex === params.rowIndex) {
            node.setDataValue('splitAmount', value)
            node.setDataValue('restAmount', restAmount)
          }
        })
        this.splitTransactionInfo.money = value
        return
      }
      // note change
      if (colNm === 'note') {
        const agGrid = this.$refs.splitAmountGrid.gridApi
        agGrid.forEachNode(node => {
          if (node.rowIndex === params.rowIndex) {
            node.setDataValue('note', value)
          }
        })
        this.splitTransactionInfo.note = value

        return
      }
      // Split percent change
      if (colNm === 'splitPercent' && value) {
        const splitAmount = (
          Number(value) *
          0.01 *
          Number(this.splitRows[params.rowIndex]['money'])
        ).toFixed()
        const restAmount =
          Number(this.splitRows[params.rowIndex]['money']) - splitAmount
        const agGrid = this.$refs.splitPercentGrid.gridApi
        agGrid.forEachNode(node => {
          if (node.rowIndex === params.rowIndex) {
            node.setDataValue('splitAmount', splitAmount)
            node.setDataValue('restAmount', restAmount)
          }
        })
        this.splitTransactionInfo.money = splitAmount
        return
      }
      // Table: transactionGrid
      // amountExcludeTax change
      if (colNm === 'amountExcludeTax' && value) {
        const feeAmount =
          Number(value) *
          0.01 *
          Number(this.dialogTransacRows[params.rowIndex]['service_fee'])
        const taxMount =
          Number(value) *
          0.01 *
          Number(this.dialogTransacRows[params.rowIndex]['tax'])
        const money = Number(value) + feeAmount + taxMount
        const agGrid = this.$refs.dialogTransactionGrid.gridApi
        agGrid.forEachNode(node => {
          if (node.rowIndex === params.rowIndex) {
            node.setDataValue('feeAmount', feeAmount)
            node.setDataValue('taxAmount', taxMount)
            node.setDataValue('taxAmount', taxMount)
            node.setDataValue('money', money)
            node.setDataValue('amountExcludeTax', value)
          }
        })
      }
      // money (amountIncludeTax) change
      this.rows2[params.rowIndex]['money_total'] =
        value * Number(this.rows2[params.rowIndex]['price'])
      const agGrid = this.$refs.agGrid2.gridApi
      agGrid.forEachNode(node => {
        if (node.rowIndex === params.rowIndex) {
          node.setDataValue(
            'money_total',
            this.rows2[params.rowIndex]['money_total']
          )
        }
      })
      this.rows2[params.rowIndex][colNm] = value
      let amount = 0
      this.rows2.forEach(item => {
        if (Number(item.quantity) && Number(item.price)) {
          amount += Number(item.quantity) * Number(item.price)
        }
      })
      this.kpItem.money_total = amount
    },
    changeInvoiceDiscountTp() {
      this.kpItem.invoice_discount_value = 0
    },
    onChangeSplitTransactionType() {
      this.splitRows[0].restAmount = this.splitRows[0].money
      this.splitRows[0].splitAmount = null
      this.splitRows = JSON.parse(JSON.stringify(this.splitRows))
      // this.splitRows = JSON.parse(JSON.stringify(this.dfSplitRows))
    },
    // onTabClick(params) {

    //   switch (Number(params.index)) {
    //     case 0:
    //       this.paymentOptions = this.paymentTransactionConfig.filter(
    //         item => item.method_nm === 'CASH_PAYMENT'
    //       )
    //       this.isVTab = true
    //       break
    //     case 1:
    //       this.paymentOptions = this.paymentTransactionConfig.filter(
    //         item => item.method_nm === 'DEBT_PAYMENT'
    //       )
    //       break
    //     case 2:
    //       this.paymentOptions = this.paymentTransactionConfig.filter(
    //         item => item.method_nm === 'CREDIT_CARD_PAYMENT'
    //       )
    //       break
    //     case 3:
    //       this.paymentOptions = this.paymentTransactionConfig.filter(
    //         item => item.method_nm === 'TRANSFER_PAYMENT'
    //       )
    //       break
    //     case 4:
    //       this.paymentOptions = this.paymentTransactionConfig.filter(
    //         item => item.method_nm === 'PREPAID_CARD_PAYMENT'
    //       )
    //       break
    //     default:
    //       break
    //   }
    //   this.tab = params.index
    // },
    // async submitPaymentForm() {
    // this.$refs.paymentComponent.submitPaymentForm()
    // },
    // async submitRefundForm() {
    // this.$refs.refundComponent.submitRefundForm()
    // },
    openRefundDialog(refundType) {
      // 1: have invoice
      // 2: no invoice
      this.$refs.refundComponent.openDialog(refundType)
    },
    openPaymentDialog(type) {
      // this.paymentDialog = true
      // this.paymentType = type
      // this.keyA++
      this.$refs.paymentComponent.openDialog()
      // if (type === 'payment') {
      //   this.paymentTitle = 'Thanh toán đặt phòng'
      // setTimeout(() => {
      // this.$refs.paymentComponent.getMoneyPayment()
      // }, 500)
      // } else {
      //   this.paymentTitle = 'Hoàn tiền'
      // }
    },
    async onSaveSplitAmount() {
      if (
        (await this.$vxForm.isValid(this.$refs.splitFormValidator)) === false
      ) {
        return
      }
      this.splitMoneyForm.id = this.transactions[0].id
      await splitTransaction(this.splitMoneyForm)
        .then(async res => {
          const message = res.message
          this.splitTransactionDialog = false
          this.transactionProcessDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.$store.dispatch('cashier/changeTransactionListIndex')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    searchRoomOnTransferTransactionDialog() {
      // this.searchFolioType = type
      // this.searchFolioDialog = true
      this.$refs.searchFolioComponent.searchFolioDialog = true
      this.searchFolioComponentIndex++
    },
    async onTransferTransaction() {
      const ids = {
        list_ids: this.transactions.map(item => item.id)
      }
      const data = { ...this.transferTransactionSubmitForm, ...ids }
      await transferTransactionApi(data)
        .then(async res => {
          const message = res.message
          this.transferTransactionDialog = false
          this.transactionProcessDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.$store.dispatch('cashier/changeTransactionListIndex')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async onCancelTransaction() {
      const params = {
        id: this.transactions[0].id,
        note: this.cancelTransaction.reason
      }
      await cancelTransaction(params)
        .then(async res => {
          const message = res.message
          // await this.attachData()
          this.isCancelTransaction = false
          this.transactionProcessDialog = false
          // await this.getTranPageById()
          // await this.getTransactionByPage()
          // this.tabIndex = this.tabList.length
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.$store.dispatch('cashier/changeTransactionListIndex')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async onTransactionProcess() {
      switch (this.transactionProcessValue) {
        case '1':
          this.isDetailPopup = true
          if (this.transactions[0].transaction_type === 1) {
            this.$refs.AddHouseKeepingServiceDialog.onEdit(
              this.transactions[0].sub_booking_service_id
            )
          } else if (this.transactions[0].transaction_type === 2) {
            // add multi-transactions
            this.$refs.editTransactionComponent.modifyTransactionDialog = true
            this.$refs.editTransactionComponent.buildInitData()
          } else if (this.transactions[0].transaction_type === 3) {
            // add service-transctions
            this.openUpdateServiceDialog()
          }
          // this.editTransactionDialog = true
          break
        case '2':
          if (this.transactions[0].transaction_type === 1) {
            this.$refs.AddHouseKeepingServiceDialog.onEdit(
              this.transactions[0].sub_booking_service_id
            )
          } else if (this.transactions[0].transaction_type === 2) {
            // add multi-transactions
            this.$refs.editTransactionComponent.modifyTransactionDialog = true
            this.$refs.editTransactionComponent.buildInitData()
          } else if (this.transactions[0].transaction_type === 3) {
            // add service-transctions
            this.openUpdateServiceDialog()
          }
          // this.editTransactionDialog = true
          break
        case '3':
          // cancel
          this.isCancelTransaction = true
          break
        case '4':
          this.transferTransactionDialog = true
          break
        case '5':
          this.splitTransactionDialog = true
          this.dfSplitRows.push(this.transactionInfo)
          this.splitRows.push(this.transactionInfo)
          break
        default:
          this.transactionProcessDialog = false
          break
      }
    },
    openTransactionProcessDialog() {
      this.transactionProcessDialog = true
    },
    // openHKSDialog() {
    //   this.addHKSDialog = true
    // },
    // async submitAddFutureRoomFee() {
    //   await addRoomCharge(this.roomChargeForm)
    //     .then(async res => {
    //       const agGrid = this.$refs.customerGrid.gridApi
    //       const row = agGrid.getSelectedRows()[0]
    //       const params = {
    //         id: row.id,
    //         transPage: this.tabList[0]?.value
    //       }
    //       const message = res.message
    //       await getTransactionByPage(params)
    //       this.addRoomFeeDialog = false
    //       this.$message({
    //         type: 'success',
    //         message: this.$t(`successMsg.${message}`)
    //       })
    //     })
    //     .catch(error => {
    //       const message = error.response?.data?.message || 'default'
    //       this.$message({
    //         type: 'error',
    //         message: this.$t(`errorMsg.${message}`)
    //       })
    //     })
    // },
    // openAddRoomFeeDialog() {
    //   this.roomChargeForm.subBookingGroupId = this.bookingInfo.id
    //   this.addRoomFeeDialog = true
    // },
    addTransactionRow() {
      this.dialogTransacRows.push({
        trans_page: null,
        transaction_desc: null,
        booking_code: null,
        amountExcludeTax: null,
        service_fee: null,
        feeAmount: null,
        tax: null,
        taxAmount: null,
        money: null
      })
    },
    onAddRowInGrid() {
      this.addTransactionRow()
    },
    async submitRoomTransaction() {
      const params = {
        subBookingGroupId: this.bookingInfo.id,
        transDate: this.customerInfo.transDate,
        note: this.transactionInfoForCustomer.note
      }
      await addMultiRoomTransaction(this.dialogTransacRows, params)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.transactionDialog = false
          this.$store.dispatch('cashier/changeTransactionListIndex')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onChangeTransDate(value) {
      this.customerInfo.transDate = value
    },
    async openTransactionDialog() {
      await this.$refs.addMultipleTransactionsComponent.fnGetSpecServiceOptions()
      this.$refs.addMultipleTransactionsComponent.openTransactionDialog()
      this.addMultipleTransactionsIndex++
    },

    handlePrintInvoice() {
      bus.$emit('post_transaction/show_print_invoice_dialog')
    },
    handlePrintProvisionalInvoice() {
      bus.$emit('post_transaction/show_print_provisional_invoice_dialog')
    },
    handlePrintDetailInvoice() {
      bus.$emit('post_transaction/show_print_detail_invoice_dialog')
    }
  }
}
</script>
